var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.color != '')?_c('div',{staticClass:"columns",class:[!_vm.values ? 'round' + _vm.color : 'round' + _vm.color + ' active'],attrs:{"id":_vm.teamsId + '_' + _vm.name + '_' + _vm.color},on:{"click":function($event){return _vm.saveColor()}}},[(_vm.values)?_c('span',[_vm._v(" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }